import {CTA, styled} from '@volkswagen-onehub/components-core';
import React, {Dispatch, SetStateAction, useContext} from 'react';
import {
  updateSavedFavourites,
  useFavouritesStore,
} from '../../store/favourites';
import {getLang} from '../../translations';
import {LinkIcon} from '../../svg/LinkIcon';
import { AppContext } from '../../app-context';

interface CopyLinkInterface {
  copy: string;
  onShowCopyLink: Dispatch<SetStateAction<boolean>>;
}

const CopyLinkContainer = styled.div`
  background-color: #f3f4f5;
  padding: ${(props) => props.theme.size.dynamic0040};
`;

const CopyLink: React.FC<CopyLinkInterface> = ({copy, onShowCopyLink}) => {
  const favouritesStore = useFavouritesStore();
  const lang = getLang();
  const { pageBaseUrl } = useContext(AppContext);
  const onCopyLink = () => {
    const favourites = favouritesStore.favourites;

    if (favourites.id) {
      let link = window.location.origin;
      link += pageBaseUrl?.dispatcher[lang];
      link += '/favourites';
      link += '/' + favourites.id

      navigator.clipboard.writeText(link);
      onShowCopyLink(true);
      updateSavedFavourites(favourites.id, favourites.vins);
    }
  };

  return (
    <CopyLinkContainer>
      <CTA
        tag="button"
        emphasis="tertiary"
        icon={<LinkIcon ariaHidden />}
        onClick={onCopyLink}
      >
        {copy}
      </CTA>
    </CopyLinkContainer>
  );
};

export default CopyLink;
